// import * as React from "react";
// import { useState, useEffect } from "react";
// import {
//   Title,
//   Datagrid,
//   TextField,
//   DateField,
//   NumberField,
//   List,
//   TopToolbar,
//   ExportButton,
//   FunctionField,
//   Filter,
//   SelectInput,
//   TextInput,
//   SearchInput,
//   useDataProvider,downloadCSV,
// } from "react-admin";
// import {
//   Box,
//   Card,
//   CardContent,
//   Grid,
//   Typography,
//   Tabs,
//   Tab,
//   Paper,
//   CircularProgress,
//   Alert,
//   useTheme,
//   alpha,
//   MenuItem,
//   Select,
//   Chip,
//   Stack,
//   LinearProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
// } from "@mui/material";
// import {
//   BarChart,
//   PieChart,
//   ChartsTooltip,
//   ChartsAxis,
//   PieArcLabel,
// } from "@mui/x-charts";
// import {
//   Phone as PhoneIcon,
//   PhoneCallback as MissedCallIcon,
//   CallMade as OutgoingIcon,
//   CallReceived as IncomingIcon,
//   Schedule as DurationIcon,
//   CheckCircle as AnsweredIcon,
//   People as AgentIcon,
//   FiberManualRecord as DotIcon,
//   Call,
//   CallMade,
//   CallReceived,
//   PhoneCallback,
//   Notes,
// } from "@mui/icons-material";
// import { DatePicker } from "@mui/x-date-pickers";
// import { TextField as MuiTextField } from "@mui/material";


// import jsonExport from 'jsonexport/dist';


// const ExportProgressDialog = ({ open, page, totalPages }) => {
//   const progress = (page / totalPages) * 100;

//   return (
//     <Dialog open={open}>
//       <DialogTitle>Export in Progress</DialogTitle>
//       <DialogContent>
//         <Typography>{`Exporting page ${page} / ${totalPages}`}</Typography>
//         <LinearProgress variant="determinate" value={progress} />
//       </DialogContent>
//     </Dialog>
//   );
// };
// const convertToCSV = (rows) => {
//   if (!rows.length) return "";
//   const header = Object.keys(rows[0]).join(",");
//   const data = rows.map(r =>
//     Object.values(r).map(v => `"${String(v).replace(/"/g, '""')}"`).join(",")
//   );
//   return [header, ...data].join("\n");
// };

// export const usePaginatedExporter = () => {
//   const dataProvider = useDataProvider();
//   const [progress, setProgress] = useState({ open: false, page: 0, totalPages: 0 });

//   const exporter = async () => {
//     const perPage = 10;

//     // first call to get total
//     const first = await dataProvider.getList("call-records", {
//       pagination: { page: 1, perPage },
//       sort: { field: "id", order: "ASC" },
//       filter: {},
//     });

//     let allRecords = [...first.data];
//     const totalPages = Math.ceil(first.total / perPage);

//     setProgress({ open: true, page: 1, totalPages });

//     for (let page = 2; page <= totalPages; page++) {
//           const { data } = await dataProvider.getList("call-records", {
//         pagination: { page, perPage },
//         sort: { field: "id", order: "ASC" },
//         filter: {},
//       });
//       allRecords = [...allRecords, ...data];
//       setProgress({ open: true, page, totalPages }); // ✅ update instead of new snackbar
//     }

//     // build CSV
//     const csvData = allRecords.map(record => ({
//       ID: record.id,
//       Time: record.callDate,
//       Caller: record.src,
//       Destination: record.dst,
//       Type: record.callType,
//       Status: record.disposition,
//       Duration: record.duration,
//       Agent: record.agentId,
//       Quality: record.qualityScore,
//       Notes: record.notes?.length > 0 ? record.notes.length : 0,
//     }));

//     const csv = convertToCSV(csvData);
//       jsonExport(csvData, { rowDelimiter: ',' }, (err, csv) => {
//         if (err) {
//             console.error(err);
//             return;
//         }
//         // Add UTF-8 BOM to fix Arabic characters in Excel
//         const bom = '\uFEFF';
//         downloadCSV(bom + csv, "call_records.csv");
//     });

//     setProgress({ open: false, page: 0, totalPages: 0 }); // close dialog
//   };

//   // return exporter + UI
//   return {
//     exporter,
//     progressUI: (
//       <ExportProgressDialog
//         open={progress.open}
//         page={progress.page}
//         totalPages={progress.totalPages}
//       />
//     ),
//   };
// };

// // Utility functions
// const formatDuration = (seconds) => {
//   if (!seconds) return '0s';
//   const mins = Math.floor(seconds / 60);
//   const secs = seconds % 60;
//   return mins > 0 ? `${mins}m ${secs}s` : `${secs}s`;
// };

// // Custom Call Type Chip
// const CallTypeChip = ({ record }) => {
//   const getCallTypeProps = (type) => {
//     switch (type) {
//       case 'incoming':
//         return { icon: <CallReceived />, color: 'success', label: 'Incoming' };
//       case 'outgoing':
//         return { icon: <CallMade />, color: 'primary', label: 'Outgoing' };
//       case 'internal':
//         return { icon: <Call />, color: 'secondary', label: 'Internal' };
//       default:
//         return { icon: <PhoneCallback />, color: 'default', label: type || 'Unknown' };
//     }
//   };

//   const props = getCallTypeProps(record?.callType);
//   return (
//     <Chip
//       icon={props.icon}
//       label={props.label}
//       color={props.color}
//       size="small"
//       variant="outlined"
//     />
//   );
// };

// // Custom Status Chip
// const StatusChip = ({ record }) => {
//   const getStatusProps = (status) => {
//     switch (status?.toLowerCase()) {
//       case 'answered':
//         return { color: 'success', label: 'Answered' };
//       case 'no answer':
//         return { color: 'warning', label: 'No Answer' };
//       case 'busy':
//         return { color: 'error', label: 'Busy' };
//       case 'failed':
//         return { color: 'error', label: 'Failed' };
//       default:
//         return { color: 'default', label: status || 'Unknown' };
//     }
//   };

//   const props = getStatusProps(record?.disposition);
//   return (
//     <Chip
//       label={props.label}
//       color={props.color}
//       size="small"
//     />
//   );
// };

// // Styled Summary Card with Icons
// const SummaryCard = ({ title, value, secondaryValue, icon: Icon, color = "primary" }) => {
//   const theme = useTheme();

//   const colorMap = {
//     primary: theme.palette.primary,
//     success: theme.palette.success,
//     error: theme.palette.error,
//     warning: theme.palette.warning,
//     info: theme.palette.info,
//   };

//   const selectedColor = colorMap[color] || colorMap.primary;

//   return (
//     <Card
//       sx={{
//         height: "100%",
//         boxShadow: 3,
//         borderLeft: `4px solid ${selectedColor.main}`,
//         transition: "transform 0.2s",
//         "&:hover": {
//           transform: "translateY(-4px)",
//         },
//       }}
//     >
//       <CardContent sx={{ display: "flex", alignItems: "center" }}>
//         <Box
//           sx={{
//             backgroundColor: selectedColor.light,
//             borderRadius: "50%",
//             width: 56,
//             height: 56,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             mr: 2,
//             color: selectedColor.contrastText,
//           }}
//         >
//           <Icon fontSize="medium" />
//         </Box>
//         <Box>
//           <Typography variant="subtitle1" color="textSecondary" gutterBottom>
//             {title}
//           </Typography>
//           <Typography variant="h4" component="div" fontWeight="bold">
//             {value || 0}
//           </Typography>
//           {secondaryValue && (
//             <Typography variant="body2" color="textSecondary">
//               {secondaryValue}
//             </Typography>
//           )}
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// // Custom Legend Component
// const CustomLegend = ({ data }) => {
//   return (
//     <Box sx={{ py: 2 }}>
//       {data.map((item, index) => (
//         <Stack key={index} direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
//           <DotIcon sx={{ color: item.color, fontSize: 16 }} />
//           <Typography variant="body2">
//             {item.label}: {item.value}
//           </Typography>
//         </Stack>
//       ))}
//     </Box>
//   );
// };

// // Call Reports Filter Component (Read-only version)
// const CallReportsFilter = (props) => (
//   <Filter {...props}>
//     <SearchInput source="q" alwaysOn placeholder="Search calls..." />
//     <SelectInput
//       source="callType"
//       choices={[
//         { id: 'incoming', name: 'Incoming' },
//         { id: 'outgoing', name: 'Outgoing' },
//         { id: 'internal', name: 'Internal' },
//       ]}
//       placeholder="All call types"
//     />
//     <SelectInput
//       source="disposition"
//       choices={[
//         { id: 'ANSWERED', name: 'Answered' },
//         { id: 'NO ANSWER', name: 'No Answer' },
//         { id: 'BUSY', name: 'Busy' },
//         { id: 'FAILED', name: 'Failed' },
//       ]}
//       placeholder="All statuses"
//     />
//     <TextInput source="src" label="From" />
//     <TextInput source="dst" label="To" />
//     <TextInput source="agentId" label="Agent" />
//   </Filter>
// );

// // Read-only Datagrid for Reports
// const CallReportsDatagrid = (props) => {
//   return (
//     <Datagrid
//       {...props}
//       rowClick={false} // Disable row clicking for read-only view
//       sx={{
//         '& .RaDatagrid-row': {
//           borderLeft: '3px solid transparent',
//           '&:hover': {
//             borderLeftColor: 'primary.main',
//             backgroundColor: 'action.hover',
//           },
//         },
//       }}
//     >
//       <DateField
//         source="callDate"
//         label="Time"
//         showTime
//         sx={{ fontWeight: 'medium', minWidth: 140 }}
//       />

//       <TextField
//         source="src"
//         label="Caller"
//         sx={{ minWidth: 100 }}
//         emptyText="–"
//       />
//       <TextField
//         source="dst"
//         label="Destination"
//         sx={{ minWidth: 100 }}
//         emptyText="–"
//       />

//       <FunctionField
//         label="Type"
//         render={(record) => <CallTypeChip record={record} />}
//       />
      
//       <FunctionField
//         label="Status"
//         render={(record) => <StatusChip record={record} />}
//       />

//       <FunctionField
//         label="Duration"
//         render={(record) => (
//           <Box sx={{ textAlign: 'center', minWidth: 80 }}>
//             <Typography variant="body2" fontWeight="medium">
//               {formatDuration(record.duration)}
//             </Typography>
//             {record.billableSeconds > 0 && (
//               <Typography variant="caption" color="text.secondary">
//                 {formatDuration(record.billableSeconds)} billable
//               </Typography>
//             )}
//           </Box>
//         )}
//       />

//       <TextField
//         source="agentId"
//         label="Agent"
//         sx={{ minWidth: 100 }}
//         emptyText="–"
//       />

//       <NumberField
//         source="qualityScore"
//         label="Quality"
//         emptyText="–"
//       />

//       <FunctionField
//         label="Notes"
//         render={(record) => (
//           <Box sx={{ minWidth: 60, textAlign: 'center' }}>
//             {record.notes?.length > 0 ? (
//               <Chip
//                 label={record.notes.length}
//                 size="small"
//                 color="info"
//                 variant="outlined"
//               />
//             ) : (
//               <Typography variant="caption" color="text.secondary">
//                 –
//               </Typography>
//             )}
//           </Box>
//         )}
//       />
//     </Datagrid>
//   );
// };

// const CallReports = () => {
//   const theme = useTheme();
//   const [reportData, setReportData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [activeTab, setActiveTab] = useState(0);
//   const [timeRange, setTimeRange] = useState("");
//   const [callType, setCallType] = useState("");
//   const [disposition, setDisposition] = useState("");
//   const [agentId, setAgentId] = useState("");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const { exporter, progressUI } = usePaginatedExporter();

//   const timeRanges = [
//     { value: "", label: "All Time" },
//     { value: "today", label: "Today" },
//     { value: "yesterday", label: "Yesterday" },
//     { value: "this_week", label: "This Week" },
//     { value: "last_week", label: "Last Week" },
//     { value: "this_month", label: "This Month" },
//     { value: "last_month", label: "Last Month" },
//     { value: "last_3_months", label: "Last 3 Months" },
//     { value: "custom", label: "Custom Range" },
//   ];

//   const dispositions = [
//     { value: "", label: "All" },
//     { value: "ANSWERED", label: "Answered" },
//     { value: "NO ANSWER", label: "No Answer" },
//     { value: "BUSY", label: "Busy" },
//     { value: "FAILED", label: "Failed" },
//   ];

//   const callTypes = [
//     { value: "", label: "All" },
//     { value: "incoming", label: "Incoming" },
//     { value: "outgoing", label: "Outgoing" },
//     { value: "internal", label: "Internal" },
//   ];

//   useEffect(() => {
//     const fetchCallReportData = async () => {
//       try {
//         const token = JSON.parse(localStorage.getItem("token"));
//         const params = new URLSearchParams();
        
//         if (timeRange) params.append("timeRange", timeRange);
//         if (callType) params.append("callType", callType);
//         if (disposition) params.append("disposition", disposition);
//         if (agentId) params.append("agentId", agentId);
//         if (startDate) params.append("startDate", startDate);
//         if (endDate) params.append("endDate", endDate);

//         const url =
//           `${process.env.REACT_APP_URL}/admin/reports/calls` +
//           (params.toString() ? `?${params.toString()}` : "");
        
//         const response = await fetch(url, {
//           method: "GET",
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "application/json",
//             Authorization: "Bearer " + token,
//           },
//         });

//         if (!response.ok) throw new Error("Failed to fetch call report data");

//         const result = await response.json();
//         console.log("Call report data:", result);
//         setReportData(result.data || {});
//       } catch (err) {
//         console.error("Error fetching call report:", err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCallReportData();
//   }, [timeRange, callType, disposition, agentId, startDate, endDate]);

//   if (loading) {
//     return (
//       <Box
//         display="flex"
//         justifyContent="center"
//         alignItems="center"
//         minHeight="300px"
//       >
//         <CircularProgress size={60} />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Alert severity="error" sx={{ my: 3 }}>
//         Failed to load call report data. Please try again later.
//         <Box mt={1} fontFamily="monospace">
//           {error}
//         </Box>
//       </Alert>
//     );
//   }

//   if (!reportData) {
//     return (
//       <Alert severity="warning" sx={{ my: 3 }}>
//         No call report data available.
//       </Alert>
//     );
//   }

//   const {
//     summary,
//     charts,
//     durationStats,
//     // recentCalls,
//   } = reportData;

//   // Prepare chart data
//   const dispositionChartData = charts?.callsByDisposition?.map((item, index) => ({
//     id: index,
//     label: item.disposition,
//     value: parseInt(item.count) || 0,
//     color: item.disposition === "ANSWERED" ? theme.palette.success.main :
//            item.disposition === "NO ANSWER" ? theme.palette.warning.main :
//            item.disposition === "BUSY" ? theme.palette.warning.light :
//            theme.palette.error.main,
//   })) || [];

//   const callTypeChartData = charts?.callsByType?.map((item, index) => ({
//     id: index,
//     label: item.type || "Unknown",
//     value: parseInt(item.count) || 0,
//     color: theme.palette.primary.main,
//   })) || [];

//   const formatTime = (seconds) => {
//     if (!seconds) return "0s";
//     const mins = Math.floor(seconds / 60);
//     const secs = seconds % 60;
//     return mins > 0 ? `${mins}m ${secs}s` : `${secs}s`;
//   };

//   return (
//     <Box
//       sx={{
//         background: `linear-gradient(135deg, ${alpha(
//           theme.palette.background.default,
//           0.9
//         )} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`,
//         p: 3,
//         borderRadius: "16px",
//       }}
//     >
//       <Title title="Call Reports" />
//       <Box sx={{ mb: 4 }}>
//         <Typography
//           variant="h4"
//           fontWeight="800"
//           sx={{
//             background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//             WebkitBackgroundClip: "text",
//             WebkitTextFillColor: "transparent",
//             display: "inline-block",
//           }}
//         >
//           Call Analytics Dashboard
//         </Typography>
//       </Box>

//       {/* Summary Cards */}
//       <Grid container spacing={3} sx={{ mb: 4 }}>
//         <Grid item xs={12} sm={6} md={3}>
//           <SummaryCard
//             title="Total Calls"
//             value={summary?.totalCalls || 0}
//             icon={PhoneIcon}
//             color="primary"
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <SummaryCard
//             title="Answered Calls"
//             value={summary?.answeredCalls || 0}
//             secondaryValue={`${summary?.answerRate || 0}% answer rate`}
//             icon={AnsweredIcon}
//             color="success"
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <SummaryCard
//             title="Avg Duration"
//             value={formatTime(summary?.avgDuration || 0)}
//             secondaryValue={`${summary?.missedCalls || 0} missed calls`}
//             icon={DurationIcon}
//             color="info"
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <SummaryCard
//             title="Unique Callers"
//             value={summary?.uniqueCallers || 0}
//             secondaryValue={`${formatTime(summary?.totalDuration || 0)} total talk time`}
//             icon={AgentIcon}
//             color="warning"
//           />
//         </Grid>
//       </Grid>

//       {/* Filters */}
//       <Card sx={{ mb: 3, p: 2 }}>
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12} sm={6} md={2}>
//             <Typography variant="subtitle2">Time Range</Typography>
//             <Select
//               fullWidth
//               value={timeRange}
//               onChange={(e) => setTimeRange(e.target.value)}
//               size="small"
//             >
//               {timeRanges.map((range) => (
//                 <MenuItem key={range.value} value={range.value}>
//                   {range.label}
//                 </MenuItem>
//               ))}
//             </Select>
//           </Grid>
//           <Grid item xs={12} sm={6} md={2}>
//             <Typography variant="subtitle2">Call Type</Typography>
//             <Select
//               fullWidth
//               value={callType}
//               onChange={(e) => setCallType(e.target.value)}
//               size="small"
//             >
//               {callTypes.map((type) => (
//                 <MenuItem key={type.value} value={type.value}>
//                   {type.label}
//                 </MenuItem>
//               ))}
//             </Select>
//           </Grid>
//           <Grid item xs={12} sm={6} md={2}>
//             <Typography variant="subtitle2">Disposition</Typography>
//             <Select
//               fullWidth
//               value={disposition}
//               onChange={(e) => setDisposition(e.target.value)}
//               size="small"
//             >
//               {dispositions.map((disp) => (
//                 <MenuItem key={disp.value} value={disp.value}>
//                   {disp.label}
//                 </MenuItem>
//               ))}
//             </Select>
//           </Grid>
//           <Grid item xs={12} sm={6} md={3}>
//             <Typography variant="subtitle2">Agent ID</Typography>
//             <MuiTextField
//               fullWidth
//               size="small"
//               value={agentId}
//               onChange={(e) => setAgentId(e.target.value)}
//               placeholder="Enter agent ID"
//             />
//           </Grid>
//           {timeRange === "custom" && (
//             <>
//               <Grid item xs={12} sm={6} md={2}>
//                 <DatePicker
//                   label="Start Date"
//                   value={startDate || null}
//                   onChange={(newDate) => {
//                     const iso = newDate ? newDate.toISOString().slice(0, 10) : "";
//                     setStartDate(iso);
//                   }}
//                   renderInput={(params) => (
//                     <MuiTextField
//                       {...params}
//                       fullWidth
//                       size="small"
//                       inputProps={{ ...params.inputProps, readOnly: true }}
//                     />
//                   )}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6} md={2}>
//                 <DatePicker
//                   label="End Date"
//                   value={endDate || null}
//                   onChange={(newDate) => {
//                     const iso = newDate ? newDate.toISOString().slice(0, 10) : "";
//                     setEndDate(iso);
//                   }}
//                   renderInput={(params) => (
//                     <MuiTextField
//                       {...params}
//                       fullWidth
//                       size="small"
//                       inputProps={{ ...params.inputProps, readOnly: true }}
//                     />
//                   )}
//                 />
//               </Grid>
//             </>
//           )}
//         </Grid>
//       </Card>

//       {/* Tabs */}
//       <Box sx={{ mb: 3 }}>
//         <Paper elevation={2}>
//           <Tabs
//             value={activeTab}
//             onChange={(e, newValue) => setActiveTab(newValue)}
//             indicatorColor="primary"
//             textColor="primary"
//             variant="fullWidth"
//           >
//             <Tab label="Analytics Overview" />
//             <Tab label="All Call Records" />
//           </Tabs>
//         </Paper>
//       </Box>

//       {/* Overview Tab */}
//       {activeTab === 0 && (
//         <Grid container spacing={3}>
//           {/* Disposition Distribution */}
//           <Grid item xs={12} lg={6}>
//             <Card elevation={3} sx={{ height: "100%" }}>
//               <CardContent>
//                 <Typography variant="h6" gutterBottom fontWeight="bold">
//                   Call Disposition
//                 </Typography>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} md={8}>
//                     <Box sx={{ height: 300 }}>
//                       {dispositionChartData.length > 0 ? (
//                         <PieChart
//                           series={[
//                             {
//                               data: dispositionChartData,
//                               innerRadius: 40,
//                               outerRadius: 100,
//                               paddingAngle: 5,
//                               cornerRadius: 5,
//                               highlightScope: {
//                                 faded: "global",
//                                 highlighted: "item",
//                               },
//                               faded: {
//                                 innerRadius: 30,
//                                 additionalRadius: -30,
//                                 color: "gray",
//                               },
//                             },
//                           ]}
//                         >
//                           <ChartsTooltip />
//                           <PieArcLabel />
//                         </PieChart>
//                       ) : (
//                         <Alert severity="info">
//                           No disposition data available
//                         </Alert>
//                       )}
//                     </Box>
//                   </Grid>
//                   <Grid item xs={12} md={4}>
//                     <CustomLegend data={dispositionChartData} />
//                   </Grid>
//                 </Grid>
//               </CardContent>
//             </Card>
//           </Grid>

//           {/* Call Type Distribution */}
//           <Grid item xs={12} lg={6}>
//             <Card elevation={3} sx={{ height: "100%" }}>
//               <CardContent>
//                 <Typography variant="h6" gutterBottom fontWeight="bold">
//                   Call Types
//                 </Typography>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} md={8}>
//                     <Box sx={{ height: 300 }}>
//                       {callTypeChartData.length > 0 ? (
//                         <PieChart
//                           series={[
//                             {
//                               data: callTypeChartData,
//                               innerRadius: 40,
//                               outerRadius: 100,
//                               paddingAngle: 5,
//                               cornerRadius: 5,
//                               highlightScope: {
//                                 faded: "global",
//                                 highlighted: "item",
//                               },
//                               faded: {
//                                 innerRadius: 30,
//                                 additionalRadius: -30,
//                                 color: "gray",
//                               },
//                             },
//                           ]}
//                         >
//                           <ChartsTooltip />
//                           <PieArcLabel />
//                         </PieChart>
//                       ) : (
//                         <Alert severity="info">
//                           No call type data available
//                         </Alert>
//                       )}
//                     </Box>
//                   </Grid>
//                   <Grid item xs={12} md={4}>
//                     <CustomLegend data={callTypeChartData} />
//                   </Grid>
//                 </Grid>
//               </CardContent>
//             </Card>
//           </Grid>
//         </Grid>
//       )}

//       {/* All Call Records Tab */}
//       {activeTab === 1 && (
//         <Grid container spacing={3}>
//           <Grid item xs={12}>
//             <List
//               resource="call-records"
//               filters={<CallReportsFilter />}
//              // actions={<ExportListAction />}
//               exporter={exporter}
//               perPage={25}
//               sort={{ field: 'callDate', order: 'DESC' }}
//               sx={{
//                 '& .RaList-content': {
//                   boxShadow: 'none',
//                   backgroundColor: 'transparent',
//                 }
//               }}
//             >
//               {progressUI}
//               <CallReportsDatagrid />
//             </List>
//           </Grid>
//         </Grid>
//       )}
//     </Box>
//   );
// };

// export default CallReports;

// export const ExportListAction = () => (
//   <TopToolbar>
//     <ExportButton />
//   </TopToolbar>
// );
// src/modules/reports/CallRecords.js (or wherever you use it)
import CallReports from '../components/reports/calls/CallReports';

export default CallReports;